"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const GridCol = (0, react_1.forwardRef)(({ children, className, desktop, mobile, tablet, width, ...props }, ref) => {
    const baseClassesString = (0, uswds_react_utils_1.createClassString)(width && `grid-col-${width}`, desktop && `desktop:grid-col-${desktop}`, mobile && `mobile-lg:grid-col-${mobile}`, tablet && `tablet:grid-col-${tablet}`);
    const allClassesString = (0, uswds_react_utils_1.createClassString)(baseClassesString, !baseClassesString && 'grid-col', className);
    return ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: allClassesString, ...props, children: children }));
});
exports.default = GridCol;
